import {DashedEdge} from './SequenceDiagram/DashedEdge';

export const edgeTypes = {
  dashed: DashedEdge,
};
